import { ChildEnrollmentAddEditForm } from 'components/templates';
import { useAppMutation } from 'services/reactQuery/useAppMutation';
import { ChildEnrollmentFormFields } from 'types';
import { useNavigateWithState } from 'hooks/useNavigateWithState/useNavigateWithState';
import { appPaths } from 'consts/paths/paths';
import EnrollmentHTTPService from 'services/HTTPService/enrollment/EnrollmentHTTPService';
import { parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO } from 'utils/parsers/enrollment/parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO';
import { EnrollmentId } from 'types/enrollment/enrollment';

export const EnrollmentAdd = () => {
    const { statefulNavigate } = useNavigateWithState();

    const onAddChildEnrollmentSuccess = () =>
        statefulNavigate(appPaths.enrollment.success, {
            replace: true,
        });

    const {
        mutate: addChildEnrollment,
        error: addChildEnrollmentError,
        isLoading: isAddChildEnrollmentLoading,
    } = useAppMutation(EnrollmentHTTPService.addChildEnrollment, {
        key: ['ADD_CHILD_ENROLLMENT'],
        onSuccess: onAddChildEnrollmentSuccess,
        invalidateQueryKeys: [['CHILD_ENROLLMENTS']],
    });

    const onAddChildEnrollmentFinish = (childEnrollmentFormFields: ChildEnrollmentFormFields) => {
        const parsedAddChildEnrollmentDto =
            parseChildEnrollmentFormFieldsIntoCreateChildEnrollmentDTO(childEnrollmentFormFields);
        addChildEnrollment({
            // TODO: to pass enrollmentId to the backend
            enrollmentId: '' as EnrollmentId,
            createChildEnrollmentDTO: parsedAddChildEnrollmentDto,
        });
    };

    return (
        <ChildEnrollmentAddEditForm
            mode="add"
            axiosError={addChildEnrollmentError}
            isLoading={isAddChildEnrollmentLoading}
            onFinish={onAddChildEnrollmentFinish}
        />
    );
};
